/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';

const ClientCount = ({ ClientCountData }) => {
    const counts = ClientCountData;
    // const [animatedCounts, setAnimatedCounts] = useState(counts.map(({ value }) => 0));
    const [animatedCounts, setAnimatedCounts] = useState(
        counts.map(() => 0)
    );

    useEffect(() => {
        const duration = 2000; // 2 seconds
        const startTime = performance.now();

        function animate(now) {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1); // 0 → 1

            setAnimatedCounts(
                counts.map(({ value }) => Math.round(value * progress))
            );

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        }

        requestAnimationFrame(animate);
    }, [counts]);

    return (
        <section className='main-client'>
            <div className="mini-spacer client-count text-white">
                <Container>
                    <div className="d-flex justify-content-between">
                        {counts?.map((count, index) => (
                            <div key={count.id} className="display-7 text-center">
                                <h1 className="m-0">
                                    {index === 3 ? `${animatedCounts[index]}%` : animatedCounts[index] > 10 ? animatedCounts[index] : `0${animatedCounts[index]}`}
                                </h1>
                                <span>{count.label}</span>
                            </div>
                        ))}
                    </div>
                </Container>
            </div>
        </section>
    );
}

export default ClientCount;